export default "__VITE_ASSET__CJnLtJhQ__"